export default __webpack_public_path__ + "static/media/Commander's Chestplate of the Battlements.ce577e0c.jpg";